import packageJson from "../../package.json";

export const APP_NAME = "Brainware University";
export const PERSIST_STORE_NAME = "brainware";
export const REDIRECT_URL_KEY = "redirectUrl";

export const APP_VERSION = packageJson.version;
